import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgLoadingComponent } from './pg-loading/pg-loading.component';
import { SafePipe } from './safe.pipe';
import { StripHTMLPipe } from './strip-html.pipe';
import { TranslatorDirective, FormatterDirective } from './localization.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExternalLinksDirective } from './external-links.directive';
import { LocTranslatePipe, LocFormatPipe, LocIconPipe } from './localization.pipe';
import { PgAnimationsDirective } from './pg-animations.directive';
import { PgUploadButtonComponent } from './pg-upload-button/pg-upload-button.component';
import { PgQrcodeComponent } from './pg-qrcode/pg-qrcode.component';
import { PgGraphComponent } from './pg-graph/pg-graph.component';
import { PgCookieConsentComponent } from './pg-cookie-consent/pg-cookie-consent.component';
import { PgShowcaseComponent } from './pg-showcase/pg-showcase.component';
import { PgMaintenanceComponent } from './pg-maintenance/pg-maintenance.component';
import { PgLanguageSelectorComponent } from './pg-language-selector/pg-language-selector.component';
import { PgNotificationComponent } from './pg-notification/pg-notification.component';
import { PgImageAutosizeComponent } from './pg-image-autosize/pg-image-autosize.component';
import { PgViewMoreComponent } from './pg-view-more/pg-view-more.component';
import { PgModalComponent } from './pg-modal/pg-modal.component';
import { PgCustomerCareBookingComponent } from './pg-customer-care-booking/pg-customer-care-booking.component';
import { CustomFnPipe } from './custom-fn.pipe';
import { PgMapLinkComponent } from './pg-map-link/pg-map-link.component';
import { PwaInstallGuideModalComponent } from './pwa-install-guide-modal/pwa-install-guide-modal.component';
import { PgShareComponent } from './pg-share/pg-share.component';
import { PgTagImageComponent } from './pg-tag-image/pg-tag-image.component';

@NgModule({
    declarations: [
        PgLoadingComponent,
        TranslatorDirective,
        FormatterDirective,
        SafePipe,
        StripHTMLPipe,
        LocTranslatePipe,
        LocFormatPipe,
        ExternalLinksDirective,
        PgAnimationsDirective,
        PgUploadButtonComponent,
        PgQrcodeComponent,
        PgGraphComponent,
        PgCookieConsentComponent,
        PgShowcaseComponent,
        PgMaintenanceComponent,
        PgLanguageSelectorComponent,
        PgNotificationComponent,
        PgImageAutosizeComponent,
        LocIconPipe,
        PgViewMoreComponent,
        PgModalComponent,
        PgCustomerCareBookingComponent,
        CustomFnPipe,
        PgMapLinkComponent,
        PwaInstallGuideModalComponent,
        PgShareComponent,
        PgTagImageComponent
    ],
    imports: [
        CommonModule,
        NgbModule
    ],
    exports: [
        PgLoadingComponent,
        TranslatorDirective,
        FormatterDirective,
        SafePipe,
        StripHTMLPipe,
        LocTranslatePipe,
        LocFormatPipe,
        ExternalLinksDirective,
        PgAnimationsDirective,
        PgUploadButtonComponent,
        PgQrcodeComponent,
        PgGraphComponent,
        PgCookieConsentComponent,
        PgShowcaseComponent,
        PgMaintenanceComponent,
        PgLanguageSelectorComponent,
        PgNotificationComponent,
        PgImageAutosizeComponent,
        LocIconPipe,
        PgViewMoreComponent,
        PgModalComponent,
        PgCustomerCareBookingComponent,
        CustomFnPipe,
        PgMapLinkComponent,
        PgShareComponent,
        PgTagImageComponent
    ]
})
export class PgUiElementsModule { }
